import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07473aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-spinner" }
const _hoisted_2 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 409.9 409.9",
  style: {"enable-background":"new 0 0 409.9 409.9"},
  "xml:space": "preserve"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<g data-v-07473aae><g class=\"logo\" data-v-07473aae><path class=\"st0\" d=\"M192.9,204.9h-69.8L105.7,215c-16.7,9.6-22.4,31-12.8,47.7c9.6,16.7,31,22.4,47.7,12.8l17.5-10.1h69.8\n\t\t\tL192.9,204.9z\" data-v-07473aae></path><path class=\"st0\" d=\"M192.9,204.9l35-48v-12.5v-20.2c0-19.3-15.6-34.9-34.9-34.9s-34.9,15.6-34.9,34.9v20.2l-34.9,60.5H192.9z\" data-v-07473aae></path><path class=\"st0\" d=\"M280.3,215l-17.4-10.1l-34.9-48l-35,48l35,60.5l17.5,10.1c16.7,9.6,38.1,3.9,47.7-12.8\n\t\t\tC302.7,246,297,224.6,280.3,215z\" data-v-07473aae></path><path class=\"st1\" d=\"M292.6,146.4c-9.9-16.2-30.9-21.4-47.2-12L193,164.6l-17.4,10.1c-7.8,4.5-17.5-1.1-17.5-10.1v-20.1l-17.1-9.9\n\t\t\tc-16.7-9.6-38.2-4.3-47.9,12.3c-9.8,16.7-4.2,38.3,12.6,48l69.8,40.3c7.8,4.5,7.8,15.7,0,20.2l-17.4,10.1l0,20.2\n\t\t\tc0,19.3,15.8,34.9,34.7,34.9c19.4,0,35.2-15.5,35.2-34.9l0-80.6c0-9,9.7-14.6,17.5-10.1l17.4,10.1l17-9.8\n\t\t\tC296.9,185.2,302.9,163.2,292.6,146.4z\" data-v-07473aae></path></g></g>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_5, _toDisplayString(_ctx.text), 1))
      : _createCommentVNode("", true)
  ]))
}